import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  API,
  TableTelemetryLog,
} from 'vibeguide';

class TelemetryLog extends PureComponent {
  constructor(props) {
    super(props);

    this.socketEventsRegistered = false;
  }

  componentDidMount() {
    const {
      socket,
    } = this.props;

    if (socket.connected) {
      socket.on('VAPI_EVENT', this.onApiEvent);
      this.socketEventsRegistered = true;
    }
  }

  componentDidUpdate(prevProps) {
    const {
      socket,
      device,
    } = this.props;

    const {
      device: prevDevice,
    } = prevProps;

    if (!this.socketEventsRegistered && socket.connected) {
      socket.on('VAPI_EVENT', this.onApiEvent);
      this.socketEventsRegistered = true;
    }

    if (prevDevice._id && device._id !== prevDevice._id) {
      document.dispatchEvent(new Event('onUpdateTableTelemetryLog'));
    }
  }

  componentWillUnmount() {
    const {
      socket,
    } = this.props;

    socket.off('VAPI_EVENT', this.onApiEvent);
  }

  onApiEvent = async (e) => {
    switch (e.type) {
      // When a media item is being played
      case 'LOCATION.CAPTURED_MEDIA_PLAYED': {
        // tell listening components to update the table
        document.dispatchEvent(new Event('onUpdateTableTelemetryLog'));
        break;
      }

      default:
        // console.warn('Event', e);
        break;
    }
  };

  render() {
    const {
      currentLocation: {
        _id,
      },
      device,
    } = this.props;

    if (!_id || !device._id) {
      return null;
    }

    return (
      <TableTelemetryLog
        columns={[
          'Timestamp',
          'Device Status',
          'Level',
          'View',
          'Message',
          '...',
        ]}
        fetch={API.Location.Telemetry.Device.getLog}
        fetchProps={{
          filters: {
            _id,
            deviceId: device._id,
          },
        }}
        defaultSortBy={{
          label: 'Timestamp',
          attr: 'timestamp',
          direction: 'desc',
        }}
        paginator
        paginatorProps={{
          label: 'Logs',
          urlPaging: true,
          urlFilters: true,
        }}
      />
    );
  }
}

TelemetryLog.propTypes = {
  device: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    currentLocation: state.locations.currentLocation,
    socket: state.socket.connection,
  };
}

export default connect(mapStateToProps)(TelemetryLog);
